"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeekDayNameViewModel = void 0;
class WeekDayNameViewModel {
    constructor(weekModelParams, stringsProvider) {
        this.dayOfWeek = weekModelParams.dayOfWeek;
        this.stringsProvider = stringsProvider;
    }
    getWeekDayName() {
        return this.stringsProvider.getString('g:weekday:' + this.dayOfWeek);
    }
}
exports.WeekDayNameViewModel = WeekDayNameViewModel;
